export const eventLabelsConstants = {
 


    CREATE_EVENTLABEL_REQUEST: 'CREATE_EVENTLABEL_REQUEST',
    CREATE_EVENTLABEL_SUCCESS: 'CREATE_EVENTLABEL_SUCCESS',
    CREATE_EVENTLABEL_FAILURE: 'CREATE_EVENTLABEL_FAILURE',

    GET_GROUP_EVENTLABEL_REQUEST: 'GET_GROUP_EVENTLABEL_REQUEST',
    GET_GROUP_EVENTLABEL_SUCCESS: 'GET_GROUP_EVENTLABEL_SUCCESS',
    GET_GROUP_EVENTLABEL_FAILURE: 'GET_GROUP_EVENTLABEL_FAILURE',
};